export default function () {
  let ua = {}, agent = navigator.userAgent, m;
  ua.iPod = agent.indexOf("iPod") > -1;
  ua.iPad = agent.indexOf("iPad") > -1;
  ua.iPhone = agent.indexOf("iPhone") > -1;
  agent.indexOf("Android") > -1 && (ua.android = parseFloat(agent.slice(agent.indexOf("Android") + 8)));

  if (ua.iPad || ua.iPhone || ua.iPod) {
    m = /OS (\d+)_/.exec(agent);
    ua.iOS = parseInt(m[1], 10) || true;
  }

  ua.wp = agent.indexOf("Windows Phone") > -1;

  // 微信UA
  m = / MicroMessenger\/([0-9\.]+)/i.exec(agent);
  m && (ua.weixin = parseFloat(m[1], 10));

  // 手QUA
  m = / QQ\/([0-9\.]+)/i.exec(agent);
  m && (ua.QQ = m[1]);

  //手空
  ua.qzone = agent.indexOf("Qzone/") > -1

  // 腾讯充值APP
  m = /TencentMidas\/([0-9\.]+)/i.exec(agent)
  m && (ua.midasAPP = m[1])

  // Safari浏览器
  if (/(iPhone)+[\S|\s]*(Version\/)[\S|\s]*Safari\//i.test(agent)) {
    m = /Safari\/([0-9\.]+)/i.exec(agent)
    m && (ua.iPhoneSafari = m[1])
  }

  // 企业微信
  m = /wxwork\/([0-9\.]+)/i.exec(agent)
  m && (ua.wxWork = m[1])

  // QQ浏览器 (QQ和微信、 安卓企业微信的webview也会包含"MQQBrowser")
  if (!/ MicroMessenger\/([0-9\.]+)/i.test(agent) && !/ QQ\/([0-9\.]+)/i.test(agent) && !/wxwork\/([0-9\.]+)/i.test(agent)) {
    m = /MQQBrowser\/([0-9\.]+)/i.exec(agent)
    m && (ua.MQQBrowser = m[1])
  }

  // UC浏览器
  m = /UCBrowser\/([0-9\.]+)/i.exec(agent)
  m && (ua.UCBrowser = m[1])

  return ua
}
